import { IMessageV2Schema } from '@cian/chats-api';

import { ERequestApiStatus } from './appState';
import { TRoute } from './route';
import { IChatDataInListSchema, EType } from '../repositories/chats/entities/chat/ChatDataInListSchema';
import { IEnrichedChatSchema as ISingleChatResponse } from '../repositories/chats/entities/chat/EnrichedChatSchema';

// Количество чатов на 1 страницу
const CHATS_ON_PAGE_LIMIT = 25;

// TODO при переходе на все версии ручек - нужно этот фикс удалить
export type TChatDataInListSchema = Omit<IChatDataInListSchema, 'message'> & {
  data?: any;
  lastMessage?: IMessageV2Schema;
};

type TChatInListSchema = TChatDataInListSchema & {
  formattedDate: string;
  botId?: number | null;
};

type TChatListState = {
  status: ERequestApiStatus;
  currentPage: number;
  currentRoute: TRoute;
  chats: TChatInListSchema[];
  allChatsLoaded?: boolean;
  timestamp?: number;
  timestampSpam?: number;
  timestampArchive?: number;
  movedToSpamChatIds: string[];
  removedFromSpamChatId?: string;
  movedToArchiveChatIds: string[];
  removedFromArchiveChatId?: string;
  notClearCurrentOpenedChatId?: boolean;
  isChangeListActive: boolean;
  isFirstLoad: boolean;
  selectedChats: string[];
};

export { CHATS_ON_PAGE_LIMIT, EType as EChatInListType, TChatInListSchema, TChatListState };
export { ISingleChatResponse };
